// extracted by mini-css-extract-plugin
module.exports = {"emojiPicker":"EmojiPicker_emojiPicker__4_zxd","buttonPopover":"EmojiPicker_buttonPopover__RSc_6"};